import { asSortParams } from "@dashboard/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  checkoutListPath,
  CheckoutListUrlQueryParams,
  CheckoutListUrlSortField,
  checkoutPath,
  CheckoutUrlQueryParams,
} from "./urls";
import PaymentRecoveryDetailsView from "./views/PaymentRecoveryDetails";
import PaymentRecoveryListView from "./views/PaymentRecoveryList";

const PaymentRecoveryList = ({ location }: RouteComponentProps<any>) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: CheckoutListUrlQueryParams = asSortParams(
    qs,
    CheckoutListUrlSortField,
    CheckoutListUrlSortField.date,
    false,
  );

  return <PaymentRecoveryListView params={params} />;
};

const PaymentRecoveryDetails = ({ location, match }: RouteComponentProps<{ id: string }>) => {
  const params: CheckoutUrlQueryParams = parseQs(location.search.substr(1)) as any;

  return <PaymentRecoveryDetailsView id={decodeURIComponent(match.params.id)} params={params} />;
};

export const CheckoutsSection = () => (
  <Switch>
    <Route exact path={checkoutListPath} component={PaymentRecoveryList} />
    <Route path={checkoutPath(":id")} component={PaymentRecoveryDetails} />
  </Switch>
);

export default CheckoutsSection;
